import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fa89b9a5cw6y">
      <Routes data-id="element-1" data-mp="3fbt1wtcwi526">
        <Route element={<Layout data-id="element-3" data-mp="3f8nd7f86p56z" />} data-id="element-2" data-mp="3fb9if87lr8m1">
          <Route path="/" element={<Home data-id="element-5" data-mp="2rk41sqtu8cao" />} data-id="element-4" data-mp="2rknnmimlzktz" />
          <Route path="/services" element={<Services data-id="element-7" data-mp="2rikmb2g0a59y" />} data-id="element-6" data-mp="2rlf7wxar9w4y" />
          <Route path="/about" element={<About data-id="element-9" data-mp="2mn5bykh7iria" />} data-id="element-8" data-mp="2mmceka451ect" />
          <Route path="/contact" element={<Contact data-id="element-11" data-mp="31aqeoda66opo" />} data-id="element-10" data-mp="2mnnfm2678808" />
          <Route path="*" element={<Home data-id="element-13" data-mp="31bi7xhgaoacs" />} data-id="element-12" data-mp="31ayrk56alu0v" />
        </Route>
      </Routes>
    </BrowserRouter>;
}